// extracted by mini-css-extract-plugin
export default {"root":"success_root__DGB1X","link":"success_link__c6lx-","glitch":"success_glitch__yklfr","glitch-effect":"success_glitch-effect__-iNVh"};